<template>
  <div class="login-container">
    <!-- 动态背景 -->
    <div class="background-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>

    <el-form
      ref="registerForm"
      :model="registerForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="top"
    >
      <div class="title-container">
        <div class="logo-icon">🎓</div>
        <h3 class="title">注册账号</h3>
        <p class="subtitle">请选择注册身份，用户名和密码用于登录</p>
      </div>

      <el-form-item class="role-selection-item" label="注册身份">
        <div class="role-selection-container">
          <div class="role-button-group">
            <div
              class="role-button"
              :class="{ active: registerForm.roleId === 1 }"
              @click="registerForm.roleId = 1"
            >
              <div class="role-icon">🎓</div>
              <div class="role-text">学生</div>
            </div>
            <div
              class="role-button"
              :class="{ active: registerForm.roleId === 5 }"
              @click="registerForm.roleId = 5"
            >
              <div class="role-icon">👨‍👩‍👧</div>
              <div class="role-text">家长</div>
            </div>
          </div>
        </div>
      </el-form-item>

      <!-- <el-form-item prop="email" label="邮箱" class="input-item">
        <span class="svg-container">
          <svg-icon icon-class="email" />
        </span>
        <el-input
          ref="email"
          v-model="registerForm.email"
          placeholder="请输入邮箱"
          name="email"
          type="text"
          tabindex="1"
          auto-complete="on"
        />
      </el-form-item> -->

      <!-- <div class="code-row">
        <el-form-item prop="emailCode" label="邮箱验证码" class="code-item input-item">
          <span class="svg-container">
            <svg-icon icon-class="code" />
          </span>
          <el-input
            ref="emailCode"
            v-model="registerForm.emailCode"
            placeholder="请输入邮箱验证码"
            name="emailCode"
            type="text"
            tabindex="2"
            auto-complete="off"
          />
        </el-form-item>
        <el-button
          :disabled="emailCodeDisabled || emailCountDown > 0"
          type="primary"
          class="send-code-btn"
          @click="sendEmailCode"
        >
          {{ emailCountDown > 0 ? `${emailCountDown}秒后重试` : '发送验证码' }}
        </el-button>
      </div> -->

      <el-form-item prop="userName" label="用户名" class="input-item">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="userName"
          v-model="registerForm.userName"
          placeholder="请输入用户名（用于登录）"
          name="userName"
          type="text"
          tabindex="3"
          auto-complete="on"
        />
      </el-form-item>

      <el-form-item prop="password" label="密码" class="input-item">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :key="passwordType"
          ref="password"
          v-model="registerForm.password"
          :type="passwordType"
          placeholder="请输入密码（至少6位）"
          name="password"
          tabindex="4"
          auto-complete="on"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <el-form-item prop="checkedPassword" label="确认密码" class="input-item">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :key="checkedPasswordType"
          ref="checkedPassword"
          v-model="registerForm.checkedPassword"
          :type="checkedPasswordType"
          placeholder="请再次输入密码"
          name="checkedPassword"
          tabindex="5"
          auto-complete="on"
        />
        <span class="show-pwd" @click="showPwd2">
          <svg-icon :icon-class="checkedPasswordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <el-form-item prop="promoCode" label="推广码（选填）" class="input-item">
        <span class="svg-container">
          <i class="el-icon-ticket"></i>
        </span>
        <el-input
          ref="promoCode"
          v-model="registerForm.promoCode"
          placeholder="如有推广码请填写"
          name="promoCode"
          type="text"
          tabindex="6"
          auto-complete="off"
        />
      </el-form-item>

      <el-button
        :loading="loading"
        type="primary"
        style="width: 100%; margin-bottom: 24px"
        @click="registerFn"
      >注册账号</el-button>

      <div class="login-link-container">
        <span class="login-text">已有账号？</span>
        <router-link class="login-link" to="/login">立即登录</router-link>
      </div>
    </el-form>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
import { register } from '@/api/user'
import { Message } from 'element-ui'
import { Encrypt } from '@/utils/Secret'
export default {
  name: 'Register',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('请输入用于登录的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    const validateCheckedPassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        const emailReg = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
        if (!emailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'))
        } else {
          callback()
        }
      }
    }
    const validateEmailCode = (rule, value, callback) => {
      callback()
    }
    return {
      registerForm: {
        roleId: 1,
        email: '',
        emailCode: '',
        userName: '',
        password: '',
        checkedPassword: '',
        promoCode: ''
      },
      loginRules: {
        email: [{ required: false, trigger: 'blur', validator: validateEmail }],
        emailCode: [{ required: false, trigger: 'blur', validator: validateEmailCode }],
        userName: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        checkedPassword: [{ required: true, trigger: 'blur', validator: validateCheckedPassword }]
      },
      loading: false,
      passwordType: 'password',
      checkedPasswordType: 'password',
      redirect: undefined,
      emailCodeDisabled: false,
      emailCountDown: 0,
      emailTimer: null
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    registerFn() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 注册：邮箱+邮箱验证码校验，用户名+密码用于登录
          const registerData = {
            roleId: this.registerForm.roleId,
            userName: this.registerForm.userName,
            email: this.registerForm.email,
            emailCode: this.registerForm.emailCode,
            password: Encrypt(this.registerForm.password),
            checkedPassword: Encrypt(this.registerForm.checkedPassword),
            promoCode: this.registerForm.promoCode || ''
          }
          register(registerData)
            .then((res) => {
              this.loading = false
              if (res.code) {
                Message({ message: '注册成功，请登录', type: 'success', duration: 3 * 1000 })
                this.$router.push({ path: '/login' })
              } else {
                Message({ message: res.msg || '注册失败', type: 'error', duration: 5 * 1000 })
              }
            })
            .catch((err) => {
              this.loading = false
              console.error('注册失败:', err)
              Message({ message: '注册失败，请重试', type: 'error', duration: 5 * 1000 })
            })
        } else {
          Message({ message: '请完善用户名和密码等必填信息', type: 'warning', duration: 5 * 1000 })
        }
      })
    },
    showPwd() {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
      this.$nextTick(() => { this.$refs.password.focus() })
    },
    showPwd2() {
      this.checkedPasswordType = this.checkedPasswordType === 'password' ? '' : 'password'
      this.$nextTick(() => { this.$refs.checkedPassword.focus() })
    },
    sendEmailCode() {
      if (!this.registerForm.email) {
        Message({ message: '请先输入邮箱', type: 'warning', duration: 3 * 1000 })
        return
      }
      this.$refs.registerForm.validateField('email', (errorMsg) => {
        if (!errorMsg) {
          this.emailCodeDisabled = true
          sendRegisterEmailCode(this.registerForm.email)
            .then((res) => {
              if (res.code) {
                Message({ message: '验证码已发送到您的邮箱，请查收', type: 'success', duration: 5 * 1000 })
                this.emailCountDown = 60
                this.emailTimer = setInterval(() => {
                  this.emailCountDown--
                  if (this.emailCountDown <= 0) {
                    clearInterval(this.emailTimer)
                    this.emailCodeDisabled = false
                  }
                }, 1000)
              } else {
                Message({ message: res.msg || '发送失败，请稍后重试', type: 'error', duration: 5 * 1000 })
                this.emailCodeDisabled = false
              }
            })
            .catch((err) => {
              console.error('发送邮箱验证码失败:', err)
              Message({ message: '发送失败，请检查邮箱是否正确', type: 'error', duration: 5 * 1000 })
              this.emailCodeDisabled = false
            })
        } else {
          Message({ message: '请先输入正确的邮箱', type: 'warning', duration: 3 * 1000 })
        }
      })
    }
  },
  beforeDestroy() {
    if (this.emailTimer) {
      clearInterval(this.emailTimer)
    }
  }
}
</script>

<style lang="scss" scoped>
$bg: #0f172a;
$bg_light: #1e293b;
$light_gray: #f1f5f9;
$dark_gray: #94a3b8;
$primary: #3b82f6;
$primary_hover: #2563eb;
$surface: rgba(255, 255, 255, 0.08);
$border: rgba(255, 255, 255, 0.1);
$surface_hover: rgba(255, 255, 255, 0.12);
$accent: #8b5cf6;
$success: #10b981;

.login-container {
  min-height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  // 动态背景装饰
  .background-decoration {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;

    .circle {
      position: absolute;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: float 20s infinite ease-in-out;
    }

    .circle-1 {
      width: 500px;
      height: 500px;
      top: -250px;
      left: -250px;
      animation-delay: 0s;
    }

    .circle-2 {
      width: 400px;
      height: 400px;
      bottom: -200px;
      right: -200px;
      animation-delay: 7s;
    }

    .circle-3 {
      width: 300px;
      height: 300px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation-delay: 14s;
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translate(0, 0) scale(1);
    }
    33% {
      transform: translate(50px, -50px) scale(1.1);
    }
    66% {
      transform: translate(-30px, 30px) scale(0.9);
    }
  }

  // 更紧凑的表单布局与更明显的标签
  ::v-deep .el-form-item {
    margin-bottom: 20px; // 增加间距避免错误提示重叠
  }
  ::v-deep .el-form--label-top .el-form-item__label {
    color: #334155;
    font-weight: 600;
    font-size: 14px;
    padding: 0 0 8px 2px;
    line-height: 1.2;
  }

  // 统一输入框样式
  .input-item {
    ::v-deep .el-input__inner {
      background: #ffffff;
      border: 2px solid #e2e8f0;
      color: #334155;
      border-radius: 12px;
      padding: 12px 15px;
      padding-left: 45px;
      font-size: 15px;
      font-weight: 500;
      transition: all 0.3s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      &:hover {
        border-color: #94a3b8;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
      }

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        outline: none;
        background: #ffffff;
      }
    }
  }
  // placeholder 样式
  .input-item {
    ::v-deep .el-input__inner::placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner::-webkit-input-placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner::-moz-placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner:-ms-input-placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner::-ms-input-placeholder { color: #94a3b8; }
  }
  ::v-deep .el-textarea__inner {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid $border;
    color: $light_gray;
  }
  ::v-deep .el-textarea__inner::placeholder { color: rgba(238, 238, 238, 0.75); }
  ::v-deep .el-textarea__inner::-webkit-input-placeholder { color: rgba(238, 238, 238, 0.75); }
  ::v-deep .el-textarea__inner::-moz-placeholder { color: rgba(238, 238, 238, 0.75); }
  ::v-deep .el-textarea__inner:-ms-input-placeholder { color: rgba(238, 238, 238, 0.75); }
  ::v-deep .el-textarea__inner::-ms-input-placeholder { color: rgba(238, 238, 238, 0.75); }
  ::v-deep .el-textarea__inner:focus {
    border-color: rgba(64, 158, 255, 0.7);
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.18);
    outline: none;
  }

  .login-form {
    position: relative;
    width: 560px;
    max-width: 90%;
    padding: 48px 50px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.1),
      0 0 0 1px rgba(255, 255, 255, 0.2) inset;
    overflow: visible;
    z-index: 1;
    animation: slideUp 0.6s ease-out;
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
   .el-form-item {
    &.role-selection-item {
      padding: 0;
      height: auto;

      .role-selection-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
        padding: 0;

        .role-button-group {
          display: flex;
          gap: 12px;
          justify-content: center;
        }
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #64748b;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    pointer-events: none;
  }

  .el-form-item {
    position: relative;
  }

  .title-container {
    position: relative;
    text-align: center;
    margin-bottom: 32px;

    .logo-icon {
      font-size: 48px;
      margin-bottom: 16px;
      animation: bounce 2s infinite;
    }

    @keyframes bounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
    }

    .title {
      font-size: 32px;
      color: #1e293b;
      margin: 0 auto 8px;
      font-weight: 700;
      letter-spacing: -0.5px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .subtitle {
      font-size: 14px;
      color: #64748b;
      margin: 0;
      font-weight: 400;
    }
  }

  .show-pwd {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: #64748b;
    cursor: pointer;
    user-select: none;
    z-index: 2;
    transition: all 0.3s ease;

    &:hover {
      color: #667eea;
    }
  }

  .but {
    width: 220px;
    height: 39px;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    /* border: 1px solid; */
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    font-weight: 500;
    text-align: center;
    font-family: sans-serif;
    padding-top: 10px;
  }
  // 角色选择按钮样式优化
  .role-button-group {
    display: flex;
    gap: 16px;
    justify-content: center;

    .role-button {
      flex: 0 0 auto;
      width: 140px;
      height: 90px;
      background: #ffffff;
      border: 2px solid #e2e8f0;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

      &:hover {
        transform: translateY(-4px);
        border-color: #667eea;
        box-shadow: 0 12px 28px rgba(102, 126, 234, 0.2);
        background: #fafbff;
      }

      &.active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-color: #667eea;
        box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4);
        transform: scale(1.05);

        .role-icon {
          transform: scale(1.15);
          filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.3));
        }

        .role-text {
          color: white;
          font-weight: 700;
        }
      }

      .role-icon {
        font-size: 36px;
        margin-bottom: 10px;
        transition: all 0.3s ease;
      }

      .role-text {
        color: #334155;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        transition: all 0.3s ease;
      }
    }
  }

  // 用户类型选择样式
  .user-type-row {
    margin-top: 16px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    .role-label {
      color: #334155;
      font-size: 14px;
      font-weight: 600;
    }

    ::v-deep .el-radio-group {
      background: #ffffff;
      padding: 4px;
      border-radius: 10px;
      border: 2px solid #e2e8f0;
    }

    ::v-deep .el-radio-button__inner {
      background: transparent;
      color: #64748b;
      border: none;
      padding: 8px 20px;
      border-radius: 8px;
      font-weight: 600;
      transition: all 0.3s ease;
    }

    ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    ::v-deep .el-radio-button__inner:hover {
      background: #f1f5f9;
      color: #3b82f6;
    }
  }

  // 表单项聚焦高亮，统一交互反馈
  .el-form-item {
    transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;

    &:focus-within {
      border-color: rgba($color: $primary, $alpha: 0.7);
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.18);
      background: rgba(255, 255, 255, 0.06);
    }
  }

  // 主按钮美化
  ::v-deep .el-button--primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    padding: 14px 0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;

    &:hover, &:focus {
      transform: translateY(-2px);
      box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4);
      background: linear-gradient(135deg, #5568d3 0%, #6a3e8f 100%);
    }

    &:active {
      transform: translateY(0);
    }

    &.is-disabled, &.is-loading {
      opacity: 0.6;
      transform: none;
      box-shadow: none;
    }
  }

  // 错误提示样式
  ::v-deep .el-form-item__error {
    color: #ef4444;
    padding-left: 15px;
    font-size: 12px;
    margin-top: 6px;
    font-weight: 500;
    line-height: 1.4;
  }

  // 验证码图片风格统一
  .captcha-image {
    border: 1px solid $border;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.06);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      border-color: rgba(64, 158, 255, 0.6);
      box-shadow: 0 8px 22px rgba(64, 158, 255, 0.18);
    }
  }

  // 验证码输入行样式
  .code-row {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 18px;

    .code-item {
      flex: 1;
      margin-bottom: 0;
    }

    .send-code-btn {
      margin-top: 30px;
      min-width: 130px;
      height: 46px;
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      border-radius: 12px;
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      border: none;
      color: white;
      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }

  // 登录链接样式
  .login-link-container {
    text-align: center;
    padding: 16px 0 8px;

    .login-text {
      color: #64748b;
      font-size: 14px;
      margin-right: 8px;
    }

    .login-link {
      color: #667eea;
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      position: relative;
      transition: all 0.3s ease;

      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 2px;
        bottom: -2px;
        left: 0;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        transition: width 0.3s ease;
      }

      &:hover {
        color: #5568d3;

        &:after {
          width: 100%;
        }
      }
    }
  }
}
</style>
